
import { ActionReducerMap } from '@ngrx/store';
import { CoreState } from '../state/core.state';
import { appSettingReducer } from './app-setting.reducer';


export const coreReducer: ActionReducerMap<CoreState> = {
    appSetting: appSettingReducer,
}